// Generated by CoffeeScript 2.7.0
var base_journeys_table_comp;

import DataTableMixin from 'trunks/vue/admin/compositions/datable_table/mixin.js';

import GroupOptions from 'trunks/vue/admin/components/libs/group_options.js';

import BatchAssignmentOverlay from 'trunks/vue/admin/compositions/yet_another_workflow/batch_assignment_overlay.js';

import BatchJourneyOverlay from 'trunks/vue/admin/compositions/yet_another_workflow/batch_journey_overlay.js';

import {
  newConfirm
} from 'trunks/vue/admin/components/libs/confirm.js';

import {
  newAlertify
} from 'trunks/vue/admin/components/alert.js';

import {
  NOT_SORT_CELLS
} from 'trunks/vue/admin/components/fields/constants.js';

import {
  addBaseJourneySpecialFields,
  addAdminJourneySpecialFields
} from 'trunks/vue/admin/compositions/datable_table/table_special_fields.js';

base_journeys_table_comp = {
  mixins: [DataTableMixin],
  components: {
    'group-options': GroupOptions
  },
  data: function() {
    return {
      fixedColumnIds: [-5, -13, -10, -11],
      exportOptions: {
        record: [
          {
            id: 'all',
            value: '全部纪录'
          },
          {
            id: 'filtered',
            value: '筛选纪录'
          }
        ],
        field: [
          {
            id: 'all',
            value: '全部字段'
          },
          {
            id: 'filtered',
            value: '显示字段'
          }
        ]
      },
      downloadAttachmentOptions: [
        {
          id: 'all',
          value: '全部记录附件'
        },
        {
          id: 'filtered',
          value: '选中记录附件'
        }
      ],
      journeyIds: [],
      selectedRows: [],
      notSortCells: NOT_SORT_CELLS,
      deleteOptions: [
        {
          id: 'all',
          value: '删除所有记录'
        },
        {
          id: 'filtered',
          value: '删除记录'
        }
      ]
    };
  },
  template: `<div class="datable-table-wrapper journeys-table">
  <div class="filter-summary justify-box" v-if='filtersExist'>
    <span>筛选条件</span>
    <div class="params chips content">
      <filter-chip v-for='(filter, key) in filters'
                   :key='key'
                   :filter='filter'
                   @remove='removeFilter' />
    </div>
  </div>
  <div class="datable-table-summary justify-between">
    <div class="vertical-middle">
      <span>共 {{ totalCount }} 条记录</span>
    </div>
    <div class="actions">
      <popover position='bottom center' ref='batchRemoveJourneyPopover' customClass='action-item' size='small' :disabled='!hasRecords' type='select'>
        <template #trigger>
          <div class="btn text-btn btn-default action-item">
            <i class='slp-trash'></i>
            <span>删除</span>
          </div>
        </template>
        <template #content>
          <div class="popover-select-content">
            <div class="popover-select-body">
              <group-options :groupedOptions='[{options: recordDeleteOptions}]'
                             :multiple='false'
                             @valueChanged='exportOptionValueChangedFunc'
                             ref='deleteRecordOptionsRef'>
                <template #option-item-template='{ option }'>
                  <div v-if="option.id === 'filtered' " class="content">{{ \`\${option.value}（\${selectedRows.length}条）\` }}</div>
                  <div v-else class="content">{{ option.value }}</div>
                  <div class="tip icon">
                    <i :class="option._selected ? 'slp-check' : 'slp-empty'"></i>
                  </div>
                </template>
              </group-options>
            </div>
            <div class="popover-select-footer">
              <div class='btn text-btn' @click.stop='closeBatchRemoveJourneyPopover'>取消</div>
              <div class='btn text-btn' @click.stop='batchRemoveJourney'>确认</div>
            </div>
          </div>
        </template>
      </popover>
      <popover position='bottom center'
               type='select'
               size='normal'
               :stopPropagation='true'
               ref='filterPopover'
               customClass='action-item field-filter-popover'>
        <template #trigger>
          <div class="btn icon-btn btn-default">
            <i class="slp-toggle"></i>
          </div>
        </template>
        <template #content>
          <div class="popover-select-content">
            <div class='popover-select-header'>
              <div class='justify-between'>
                <span class='gray-text'>显示字段</span>
                <div class='content'>
                  <span v-show='!fieldsAllSelected' class='btn text-btn btn-default' @click='invertSelectFieldsFunc'>反选</span>
                  <i :class="{ 'slp-check': fieldsAllSelected, 'slp-empty': !fieldsAllSelected }"></i>
                  <span class='btn text-btn btn-default' @click='selectAllFieldsFunc'>全选</span>
                </div>
              </div>
            </div>
            <div class="popover-select-body">
              <div class='list'>
                <div class="list-item"
                    v-for='field in fields'
                    @click='toggleHideField(field)'
                    :key='field.id'>
                  <div class="content text-ellipsis">{{ field.title }}</div>
                  <i class="slp-empty" v-if='field._hidden'></i>
                  <i class="slp-check" v-else></i>
                </div>
              </div>
            </div>
          </div>
        </template>
      </popover>
      <popover position='bottom center' ref='exportPopover' customClass='action-item export-popover' size='default' :disabled='!hasRecords' type='select'>
        <template #trigger>
          <div class="btn text-btn btn-default" :class="{ disabled: !hasRecords }">
            <i class="slp-download-o"></i>
            <span>导出</span>
          </div>
        </template>
        <template #content>
          <div class="popover-select-content">
            <div class="popover-select-body">
              <group-options :groupedOptions='[{options: recordExportOptions}]'
                             :multiple='false'
                             @valueChanged='exportOptionValueChangedFunc'
                             ref='recordGroupedOptionsRef'>
                <template #option-item-template='{ option }'>
                  <div class="content">{{ option.value }}({{ option.id == 'all' ? totalRecordCount : totalCount }}条)</div>
                  <div class="tip icon">
                    <i :class="option._selected ? 'slp-check' : 'slp-empty'"></i>
                  </div>
                </template>
              </group-options>
              <group-options v-show="!fieldsAllSelected"
                             :groupedOptions='[{options: exportOptions.field}]'
                             :multiple='false'
                             @valueChanged='exportOptionValueChangedFunc'
                             ref='fieldGroupedOptionsRef'>
                <template #option-item-template='{ option }'>
                  <div class="content">{{ option.value }}</div>
                  <div class="tip icon">
                    <i :class="option._selected ? 'slp-check' : 'slp-empty'"></i>
                  </div>
                </template>
              </group-options>
            </div>
            <div class="popover-select-footer">
              <div class='btn text-btn' @click.stop='closeExportPopover'>取消</div>
              <div class='btn text-btn' @click.stop='ensureExport'>导出</div>
            </div>
          </div>
        </template>
      </popover>
      <popover position='bottom center' ref='downloadAttachmentPopover' customClass='action-item' size='default' :disabled='!hasRecords' type='select'>
        <template #trigger>
          <div class="btn text-btn btn-default" :class="{ disabled: !hasRecords }">
            <i class="slp-attachment"></i>
            <span>下载附件</span>
          </div>
        </template>
        <template #content>
          <div class="popover-select-content">
            <div class="popover-select-body">
              <group-options :groupedOptions='[{options: recordDownloadAttachmentOptions}]'
                             :multiple='false'
                             @valueChanged='downloadAttachmentOptionValueChangedFunc'
                             ref='recordDownloadAttachmentGroupedOptionsRef'>
                <template #option-item-template='{ option }'>
                  <div class="content">{{ option.value }}</div>
                  <div class="tip icon">
                    <i :class="option._selected ? 'slp-check' : 'slp-empty'"></i>
                  </div>
                </template>
              </group-options>
            </div>
            <div class="popover-select-footer">
              <div class='btn text-btn' @click.stop='closeDownloadAttachmentPopover'>取消</div>
              <div class='btn text-btn' @click.stop='ensureDownloadAttachment'>下载</div>
            </div>
          </div>
        </template>
      </popover>
      <a :href="datableUrl + '/journeys/new'" class="btn action-item none-decorate" target="_blank">
        <i class="slp-plus"></i>
        <span>发起流程</span>
      </a>
    </div>
  </div>
  <div class="preserved-filter-summary justify-box" v-if='!_.isBlank(composedPreservedFilters)' v-show='preserveredFiltersShown'>
    <span>视图条件</span>
    <div class="params chips content">
      <filter-chip v-for='(filter, filter_key) in composedPreservedFilters'
                   :key='filter_key'
                   :filter='filter'
                   :removable='false' />
    </div>
  </div>
  <v-table :headers='filterFields'
           :rows='recordRows'
           :fixedColumnIds='fixedColumnIds'
           @rowClicked='rowClickedFunc'
           @selectedRowsChanged='selectedRowsChangedFunc'
           ref='bodyTable'>
    <template #header='{ header }'>
      <header-cell v-if="notSortCells.includes(header.type)"
                   :field='header'
                   :filter='_getFilterByField(header)'
                   :order='order'
                   :hasSort="false"
                   @filterChanged='removeOrUpdateFilter'
                   @orderChanged='removeOrUpdateOrder' />
      <header-cell v-else
                   :field='header'
                   :filter='_getFilterByField(header)'
                   :order='order'
                   @filterChanged='removeOrUpdateFilter'
                   @orderChanged='removeOrUpdateOrder' />
    </template>
    <template #body='{ cell }'>
      <field-cell :field='cell.field'
                  :entries='cell.entries'
                  @cellItemClicked='displayItemIfNeed'></field-cell>
    </template>
  </v-table>
  <paginator :resourceUrl="resourceUrl"
             ref='paginator'
             :additionalParams='paginatorParams'
             :beforeRequestFunc='beforeRecordsRequestFunc'
             :afterRequestFunc='afterRecordsRequestFunc'
             @dataReceived='updateJourneys' />
</div>`,
  created: function() {
    return this._initDefaultExportOption();
  },
  computed: {
    resourceUrl: function() {
      if (this.filtersExist || this.order.value) {
        return `${this.datableUrl}/journeys/search.json`;
      } else {
        return `${this.datableUrl}/journeys.json`;
      }
    },
    hasQuerySearchParams: function() {
      return Boolean(this.searchParams.query && !(_.isBlank(this.searchParams.query)));
    },
    recordExportOptions: function() {
      if (this.hasQuerySearchParams) {
        return this.exportOptions.record;
      } else {
        return [this.exportOptions.record[0]];
      }
    },
    recordDownloadAttachmentOptions: function() {
      var all_option, filter_option;
      all_option = this.downloadAttachmentOptions[0];
      filter_option = this.downloadAttachmentOptions[1];
      if (this.journeyIds.length > 0) {
        Vue.set(all_option, '_selected', false);
        Vue.set(filter_option, '_selected', true);
        return this.downloadAttachmentOptions;
      } else {
        Vue.set(all_option, '_selected', true);
        return [all_option];
      }
    },
    recordDeleteOptions: function() {
      var all_option, filter_option;
      all_option = this.deleteOptions[0];
      filter_option = this.deleteOptions[1];
      if (this.selectedRows.length > 0) {
        Vue.set(all_option, '_selected', false);
        Vue.set(filter_option, '_selected', true);
      } else {
        Vue.set(all_option, '_selected', true);
        Vue.set(filter_option, '_selected', false);
      }
      return this.deleteOptions;
    }
  },
  watch: {
    recordExportOptions: function(new_value) {
      var all_option, filter_option;
      // reset record exportOptions
      all_option = this.exportOptions.record[0];
      filter_option = this.exportOptions.record[1];
      if (this.hasQuerySearchParams) {
        all_option._selected = false;
        return filter_option._selected = true;
      } else {
        all_option._selected = true;
        return filter_option._selected = false;
      }
    }
  },
  methods: {
    restoreHiddenSettings: function() {
      var graph_fields, hidden_ids;
      hidden_ids = localStorage.getItem(`${this.datableUrl}_hiddensetting_draft`);
      // 如果有缓存设置，则使用缓存设置
      if (hidden_ids) {
        return _.map(hidden_ids.split(','), function(id) {
          return parseInt(id);
        });
      } else {
        // 否则，隐藏graph上的字段与流程编号
        graph_fields = _.chain(this.fieldable.fields).filter(function(field) {
          return Skylark.App.Model.YetAnotherWorkflow.Graph.hasInstance(field.fieldable);
        }).pluck('id').value();
        return graph_fields.concat([-5]);
      }
    },
    updateJourneys: function(journeys, status) {
      var records;
      records = _.map(journeys || [], function(journey) {
        journey.gid = Skylark.Libs.GlobalID.locate(journey.gid);
        return _.extend({}, journey.response, journey);
      });
      return this.updateRecords(records, status);
    },
    rowClickedFunc: function(event, row, child) {
      var record, record_index;
      if (event.target.closest('.checkbox-cell') || event.target.closest('.attachment-item')) {
        return;
      }
      if (this._overlay_requesting) {
        return;
      }
      this._rowClickedFunc(event, row, child);
      record_index = _.findIndex(this.records, function(record) {
        return record.id === row.id;
      });
      if (record_index === -1) {
        return;
      }
      this._overlay_requesting = true;
      this.spinner.open();
      this.$refs.bodyTable.focusOnRow(row);
      record = this.records[record_index];
      return Skylark.Libs.Ajax.get(Skylark.Helpers.UrlHelper.generateUrlWithParams(this.rowOverlayUrl(record), this.additionalParams), {
        contentType: 'application/json; charset=utf-8',
        responseType: 'script',
        complete: () => {
          this._overlay_requesting = false;
          return this.spinner.close();
        }
      });
    },
    selectedRowsChangedFunc: function(rows) {
      this.journeyIds = _.map(rows, function(row) {
        return row.id;
      });
      this.selectedRows = _.filter(rows, function(row) {
        return row.id;
      });
      return this.$emit('selectedRowsChanged', this.journeyIds);
    },
    exportOptionValueChangedFunc: function(vm, option) {
      return this._toggleGroupOptionsValue(option);
    },
    downloadAttachmentOptionValueChangedFunc: function(vm, option) {
      return this._toggleGroupOptionsValue(option);
    },
    closeExportPopover: function() {
      return this.$refs.exportPopover.close();
    },
    closeDownloadAttachmentPopover: function() {
      return this.$refs.downloadAttachmentPopover.close();
    },
    closeBatchRemoveJourneyPopover: function() {
      return this.$refs.batchRemoveJourneyPopover.close();
    },
    ensureExport: function() {
      var export_options, field_export_option, field_op, record_export_option, record_op, ref;
      this.closeExportPopover();
      if (this._exportRequesting) {
        return;
      }
      this._exportRequesting = true;
      record_op = this.$refs.recordGroupedOptionsRef.getSelectedOptions()[0];
      record_export_option = record_op.id === 'filtered' ? {
        query: _.clone(this.searchParams.query)
      } : {};
      field_op = ((ref = this.$refs.fieldGroupedOptionsRef) != null ? ref.getSelectedOptions()[0] : void 0) || {};
      field_export_option = {
        field_ids: _.pluck((field_op.id === 'filtered' ? this.filterFields : this.field), 'id')
      };
      export_options = _.extend({}, record_export_option, field_export_option);
      return Skylark.Libs.Ajax.get(this.exportUrl, {
        data: {
          options: export_options
        },
        responseType: 'script',
        complete: () => {
          return this._exportRequesting = false;
        }
      });
    },
    ensureDownloadAttachment: function() {
      var option, params;
      this.closeDownloadAttachmentPopover();
      option = this.$refs.recordDownloadAttachmentGroupedOptionsRef.getSelectedOptions()[0];
      params = {
        download_type: option.id === 'all' ? 'full' : '',
        journey_ids: this.journeyIds
      };
      return Skylark.Libs.Ajax.post(`/admin${this.datableGID.toPath()}/journeys/download_attachments`, {
        contentType: 'application/json; charset=utf-8',
        data: params,
        success: () => {
          return newAlertify('已成功添加下载附件任务', {
            type: 'success'
          });
        },
        error: function(xhr, status, errors) {
          return newAlertify('添加下载附件任务失败', {
            type: 'error'
          });
        }
      });
    },
    _toggleGroupOptionsValue: function(option) {
      if (!option._selected) {
        return option._selected = true;
      }
    },
    _initDefaultExportOption: function() {
      return _.each(this.exportOptions, function(option_group, type) {
        var all_option, filter_option;
        all_option = option_group[0];
        filter_option = option_group[1];
        if (type === 'record') {
          Vue.set(all_option, '_selected', true);
          return Vue.set(filter_option, '_selected', false);
        } else {
          Vue.set(all_option, '_selected', false);
          return Vue.set(filter_option, '_selected', true);
        }
      });
    },
    _rowClickedFunc: function(event, row, child) {},
    // 用于子类不同的表现
    _formatRecords: function(records) {
      return records;
    },
    __parseSpecialCells: function(field, record, grouped_entries, rowspan, receivier) {
      var ref, ref1, value;
      switch (field.id) {
        case -12:
          if (record.created_at) {
            return receivier.entries = [
              {
                field_id: -12,
                value: record.created_at
              }
            ];
          }
          break;
        case -9:
          if (record.assignment_status) {
            value = record.skipped_by_user ? record.skipped_by_user + Skylark.Helpers.t(`assignment.skippedStatus.${record.assignment_status}`) : Skylark.Helpers.t(`assignment.status.${record.assignment_status}`);
            return receivier.entries = [
              {
                field_id: -9,
                value: value
              }
            ];
          }
          break;
        case -13:
          if (record.user) {
            return receivier.entries = [
              {
                field_id: -13,
                value: record.user.name,
                user: record.user
              }
            ];
          }
          break;
        case -19:
          if (record.user) {
            return receivier.entries = [
              {
                field_id: -19,
                value: record.user.identifier
              }
            ];
          }
          break;
        case -5:
          return receivier.entries = [
            {
              field_id: -5,
              value: record.sn
            }
          ];
        case -4:
          return receivier.entries = [
            {
              field_id: -4,
              value: record.pretty_assignment_current_duration_threshold
            }
          ];
        case -6:
          return receivier.entries = [
            {
              field_id: -6,
              value: Skylark.Helpers.t(`journey.status.${record.status}`),
              duration_threshold: record.pretty_current_duration_threshold
            }
          ];
        case -7:
          return receivier.entries = [
            {
              field_id: -7,
              value: record.pretty_current_duration_threshold
            }
          ];
        case -8:
          if (record.current_vertex) {
            return receivier.entries = [
              {
                field_id: -8,
                value: record.current_vertex.name,
                duration_threshold: record.pretty_assignment_current_duration_threshold
              }
            ];
          }
          break;
        case -10:
          return receivier.entries = [
            {
              field_id: -10,
              value: (ref = record.identity_certification) != null ? ref.identity_name : void 0
            }
          ];
        case -11:
          return receivier.entries = [
            {
              field_id: -11,
              value: (ref1 = record.identity_certification) != null ? ref1.identity_id : void 0
            }
          ];
        case -25:
          return receivier.entries = [
            {
              field_id: -25,
              value: record.custom_sn
            }
          ];
        default:
          return this.__parseNormalCells(field, record, grouped_entries, rowspan, receivier);
      }
    }
  }
};

export var JourneysTable = Vue.extend({
  extends: base_journeys_table_comp,
  data: function() {
    return {
      overlay: null,
      batchErrorMessage: ''
    };
  },
  template: `<div class="datable-table-wrapper journeys-table">
  <div class="filter-summary justify-box" v-if='filtersExist'>
    <span>筛选条件</span>
    <div class="params chips content">
      <filter-chip v-for='(filter, key) in filters'
                   :key='key'
                   :filter='filter'
                   @remove='removeFilter' />
    </div>
  </div>
  <div class="datable-table-summary justify-between">
    <div class="vertical-middle">
      <span>共 {{ totalCount }} 条记录</span>
    </div>
    <div class="actions">
      <popover
        position="bottom center"
        :caret='true'
        :disabled='!canHandleBatch'
        :manualToggle="true"
        type="confirm"
        size="large"
        ref="batchConfirmPopover"
        @triggerClicked="batchPopoverTriggerClickedFunc"
      >
        <template #trigger>
          <div
            class="btn text-btn btn-default action-item"
            :class="{disabled: !canHandleBatch}"
          >
            <i class='slp-check-more'></i>
            <span>批量处理</span>
          </div>
        </template>
        <template #content>
          <div class="popover-confirm-content">
            <div class="popover-confirm-title">部分节点已开启批量处理功能</div>
            <div class="popover-confirm-body">{{ batchErrorMessage }}</div>
            <div class="popover-confirm-footer">
              <div class="btn btn-small" @click="closeBatchPopover">确认</div>
            </div>
          </div>
        </template>
      </popover>
      <popover position='bottom center'
               type='select'
               size='normal'
               :stopPropagation='true'
               ref='filterPopover'
               customClass='action-item field-filter-popover'>
        <template #trigger>
          <div class="btn icon-btn btn-default">
            <i class="slp-toggle"></i>
          </div>
        </template>
        <template #content>
          <div class="popover-select-content">
            <div class='popover-select-header'>
              <div class='justify-between'>
                <span class='gray-text'>显示字段</span>
                <div class='content'>
                  <span v-show='!fieldsAllSelected' class='btn text-btn btn-default' @click='invertSelectFieldsFunc'>反选</span>
                  <i :class="{ 'slp-check': fieldsAllSelected, 'slp-empty': !fieldsAllSelected }"></i>
                  <span class='btn text-btn btn-default' @click='selectAllFieldsFunc'>全选</span>
                </div>
              </div>
            </div>
            <div class="popover-select-body">
              <div class='list'>
                <div class="list-item"
                    v-for='field in fields'
                    @click='toggleHideField(field)'
                    :key='field.id'>
                  <div class="content text-ellipsis">{{ field.title }}</div>
                  <i class="slp-empty" v-if='field._hidden'></i>
                  <i class="slp-check" v-else></i>
                </div>
              </div>
            </div>
          </div>
        </template>
      </popover>
      <popover position='bottom center' ref='exportPopover' customClass='action-item export-popover' size='default' :disabled='!hasRecords' type='select'>
        <template #trigger>
          <div class="btn text-btn btn-default" :class="{ disabled: !hasRecords }">
            <i class="slp-download-o"></i>
            <span>导出</span>
          </div>
        </template>
        <template #content>
          <div class="popover-select-content">
            <div class="popover-select-body">
              <group-options :groupedOptions='[{options: recordExportOptions}]'
                             :multiple='false'
                             @valueChanged='exportOptionValueChangedFunc'
                             ref='recordGroupedOptionsRef'>
                <template #option-item-template='{ option }'>
                  <div class="content">{{ option.value }}({{ option.id == 'all' ? totalRecordCount : totalCount }}条)</div>
                  <div class="tip icon">
                    <i :class="option._selected ? 'slp-check' : 'slp-empty'"></i>
                  </div>
                </template>
              </group-options>
              <group-options v-show="!fieldsAllSelected"
                             :groupedOptions='[{options: exportOptions.field}]'
                             :multiple='false'
                             @valueChanged='exportOptionValueChangedFunc'
                             ref='fieldGroupedOptionsRef'>
                <template #option-item-template='{ option }'>
                  <div class="content">{{ option.value }}</div>
                  <div class="tip icon">
                    <i :class="option._selected ? 'slp-check' : 'slp-empty'"></i>
                  </div>
                </template>
              </group-options>
            </div>
            <div class="popover-select-footer">
              <div class='btn text-btn' @click.stop='closeExportPopover'>取消</div>
              <div class='btn text-btn' @click.stop='ensureExport'>导出</div>
            </div>
          </div>
        </template>
      </popover>
      <a :href="datableUrl + '/journeys/new'" class="btn action-item none-decorate" target="_blank">
        <i class="slp-plus"></i>
        <span>发起流程</span>
      </a>
    </div>
  </div>
  <div class="preserved-filter-summary justify-box" v-if='!_.isBlank(composedPreservedFilters)' v-show='preserveredFiltersShown'>
    <span>视图条件</span>
    <div class="params chips content">
      <filter-chip v-for='(filter, filter_key) in composedPreservedFilters'
                   :key='filter_key'
                   :filter='filter'
                   :removable='false' />
    </div>
  </div>
  <v-table :headers='filterFields'
           :rows='recordRows'
           :fixedColumnIds='fixedColumnIds'
           @rowClicked='rowClickedFunc'
           @selectedRowsChanged='selectedRowsChangedFunc'
           ref='bodyTable'>
    <template #header='{ header }'>
      <header-cell v-if="notSortCells.includes(header.type)"
                   :field='header'
                   :filter='_getFilterByField(header)'
                   :order='order'
                   :hasSort="false"
                   @filterChanged='removeOrUpdateFilter'
                   @orderChanged='removeOrUpdateOrder' />
      <header-cell v-else
                   :field='header'
                   :filter='_getFilterByField(header)'
                   :order='order'
                   @filterChanged='removeOrUpdateFilter'
                   @orderChanged='removeOrUpdateOrder' />
    </template>
    <template #body='{ cell }'>
      <field-cell :field='cell.field'
                  :entries='cell.entries'
                  @cellItemClicked='displayItemIfNeed'></field-cell>
    </template>
  </v-table>
  <paginator :resourceUrl="resourceUrl"
             ref='paginator'
             :additionalParams='paginatorParams'
             :beforeRequestFunc='beforeRecordsRequestFunc'
             :afterRequestFunc='afterRecordsRequestFunc'
             @dataReceived='updateJourneys' />
</div>`,
  computed: {
    datableUrl: function() {
      return Skylark.Helpers.UrlHelper.namespaceUrlFor(this.datableGID.toPath());
    },
    exportUrl: function() {
      return `${this.datableUrl}/journeys/export?category=${this.additionalParams.category}`;
    },
    validSameVertexUrl: function() {
      return Skylark.Helpers.UrlHelper.namespaceUrlFor('/yet_another_workflow/assignments/valid_in_same_vertex');
    },
    canHandleBatch: function() {
      if (this.additionalParams.category === 'processed') {
        return this.selectedRows.length > 1;
      } else {
        return this.selectedRows.length > 1 && _.every(this.selectedRows, function(row) {
          return row.record.status === 'receding' || row.record.status === 'processing';
        });
      }
    }
  },
  methods: {
    rowOverlayUrl: function(record) {
      return `${Skylark.Helpers.UrlHelper.namespaceUrlFor(record.gid.toPath())}/latest_assignment`;
    },
    closeBatchPopover: function() {
      return this.$refs.batchConfirmPopover.close();
    },
    batchPopoverTriggerClickedFunc: function() {
      var flow_id;
      if (this.additionalParams.category === 'processed') {
        this.spinner.open();
        return this._batchRequestNextVertex();
      } else {
        flow_id = this.datableGID.model_id;
        if (!this.batchJourneyOverlay) {
          this.batchJourneyOverlay = new BatchJourneyOverlay({
            el: DomMaster.find('#js_batch_journeys_overlay_container').node,
            propsData: {
              flowId: flow_id,
              journeys: this.selectedRows
            }
          });
          this.batchJourneyOverlay.$on('afterRequest', function() {
            return Turbolinks.visit(Skylark.Helpers.UrlHelper.namespaceUrlFor(`yet_another_workflow/flows/${flow_id}/journeys`, {
              category: 'proposed'
            }));
          });
        }
        this.batchJourneyOverlay.updateSetting({
          flowId: flow_id,
          journeys: this.selectedRows
        });
        return this.batchJourneyOverlay.open();
      }
    },
    _batchRequestNextVertex: function() {
      return Skylark.Libs.Ajax.get(this.validSameVertexUrl, {
        data: {
          journey_ids: this.journeyIds
        },
        success: (data) => {
          return this._openBatchAssignmentOverlay(data);
        },
        error: (jqxhr, status, error) => {
          this.$refs.batchConfirmPopover.open();
          return this.batchErrorMessage = error.errors ? error.errors[0] : error.error;
        },
        complete: () => {
          return this.spinner.close();
        }
      });
    },
    _openBatchAssignmentOverlay: function({current_vertex_attributes, current_assignments_attributes}) {
      var currentVertex;
      currentVertex = new Skylark.App.Model.YetAnotherWorkflow.Vertex(current_vertex_attributes);
      currentVertex._makeFields(current_vertex_attributes.fields);
      if (!this.overlay) {
        this.overlay = new BatchAssignmentOverlay({
          el: DomMaster.find('#js_batch_journeys_overlay_container').node,
          propsData: {
            assignmentAttributes: current_assignments_attributes,
            currentVertexAttributes: current_vertex_attributes,
            currentVertex: currentVertex
          }
        });
      }
      this.overlay.updateSetting({
        assignmentAttributes: current_assignments_attributes,
        currentVertexAttributes: current_vertex_attributes,
        currentVertex: currentVertex
      });
      return this.overlay.open();
    },
    _rowClickedFunc: function(event, row, child) {
      return row.read = true;
    },
    _addSpecialFields: function(receivier, hidden_ids) {
      return addBaseJourneySpecialFields(receivier, hidden_ids, {
        processed: this.additionalParams.category === 'processed',
        enableIdentityVerify: this.fieldable.enable_identity_vertify
      });
    }
  }
});

export var JourneysTableForAdmin = Vue.extend({
  extends: base_journeys_table_comp,
  computed: {
    datableUrl: function() {
      return Skylark.Helpers.UrlHelper.adminUrlFor(this.datableGID.toPath());
    },
    exportUrl: function() {
      return `${this.datableUrl}/journeys/export`;
    }
  },
  methods: {
    batchRemoveJourney: function() {
      this.closeBatchRemoveJourneyPopover();
      return newConfirm({
        title: "确认删除选中的填写记录?",
        message: "删除操作不可撤销，请确认操作。",
        confirmButtonText: '删除',
        type: 'danger'
      }).$on('ensureClicked', () => {
        return this._removeRecords();
      });
    },
    _removeRecords: function() {
      var data, ids, record_op, url;
      record_op = this.$refs.deleteRecordOptionsRef.getSelectedOptions()[0];
      data = {};
      url = `${this.datableUrl}/journeys/batch_destroy`;
      if (record_op.id === 'all') {
        data = {
          _destroy_all: true
        };
      } else {
        ids = _.reduce(this.selectedRows, function(acc, row) {
          if (row.id) {
            if (acc) {
              acc = `${acc}&ids[]=${row.id}`;
            } else {
              acc = `${acc}?ids[]=${row.id}`;
            }
          }
          return acc;
        }, '');
        url = `${url}${ids}`;
      }
      return Skylark.Libs.Ajax.delete(url, {
        contentType: 'application/json, text/javascript',
        data: data,
        success: () => {
          newAlertify("删除成功");
          this.$refs.paginator.go();
          return this.$refs.bodyTable.resetAllSelected();
        },
        error: function() {
          return newAlertify("删除失败");
        }
      });
    },
    rowOverlayUrl: function(record) {
      var url;
      return url = `${this.datableUrl}/journeys/${record.id}`;
    },
    _addSpecialFields: function(receivier, hidden_ids) {
      return addAdminJourneySpecialFields(receivier, hidden_ids);
    }
  }
});
